const PROBE_STYLE = [
    'position: absolute',
    'top: 0',
    'left: 0',
    'visibility: hidden',
    'pointer-events: none',
    'width: max-content',
    'white-space: nowrap'
].join(';');

// Width of a cell's content on one line, paddings left out. A copy of the
// content goes into a hidden box of `max-content` width inside the cell, so
// it keeps the cell's font and the table's styles; what floats over the
// cell (the resize handle, other absolutely placed controls) is left out.
function measureCellContent(cell) {
    const probe = document.createElement('div');
    probe.setAttribute('style', PROBE_STYLE);
    probe.setAttribute('aria-hidden', 'true');
    cell.childNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
            const { position } = getComputedStyle(node);
            if (position === 'absolute' || position === 'fixed') return;
        }
        probe.appendChild(node.cloneNode(true));
    });
    cell.appendChild(probe);
    const width = probe.getBoundingClientRect().width;
    probe.remove();
    return width;
}

/**
 * Width a grid column needs to show its content in full: the head label and
 * every rendered row (the current page only — other pages are not in the
 * DOM), each on one line.
 *
 * @param {HTMLTableCellElement} headCell - The column's head cell.
 * @returns {number} the width in px, paddings included
 */
export function measureColumnContentWidth(headCell) {
    const table = headCell.closest('table');
    const index = headCell.cellIndex;
    const cellCount = headCell.parentElement.cells.length;
    let width = 0;

    Array.from(table.rows).forEach((row) => {
        // A row whose cells do not line up with the head (no results).
        if (row.cells.length !== cellCount) return;
        const cell = row.cells[index];
        const content = measureCellContent(cell);
        if (!content) return;
        const style = getComputedStyle(cell);
        width = Math.max(
            width,
            content +
                parseFloat(style.paddingLeft) +
                parseFloat(style.paddingRight)
        );
    });
    return Math.ceil(width);
}
